<template>
    <project-template>

      <project-text
      size="25"
      :color="$store.state.activeProject.color">
        <h1>Soul Grind</h1>
        <p>A cold brew coffee infused with hemp CBD. The Brooklyn-inspired aesthetic is represented in two ways: A loud, colorful, 70’s funk style look and a muted, casual, soul music style. In either style, these throwback can designs entice the consumer to pick up the can and find out what makes Soul Grind a standout in the infused cold brew category.</p>
      </project-text>

      <project-image
      size="75"
      path="/img/p/cbddrinks/soulgrind.jpg"
      alt="Soul Grind Can Design"/>

      <project-carousel
      size="75"
      :color="$store.state.activeProject.color"
      :autoplay="false">
        <slide><img v-lazy="'/img/p/cbddrinks/wickedwater.jpg'" alt="Wicked Water Can Design"></slide>
        <slide><img v-lazy="'/img/p/cbddrinks/wickedwater2.jpg'" alt="Wicked Water Can Design"></slide>
      </project-carousel>

      <project-text
      size="25"
      :color="$store.state.activeProject.color">
        <h1>Wicked Water</h1>
        <p>A high-dose THC infused sparkling water with loud, expressive branding. Option 1 features a seamless wave design, with a product name that spans across three cans. This design is meant to have a dominant, eye-catching shelf presence. Option 2 leans heavily into showing off the product’s flavor cues, while still keeping the product name at the center of attention.</p>
      </project-text>

      <project-text
      size="25"
      :color="$store.state.activeProject.color">
        <h1>Beach Ball</h1>
        <p>A CBD infused sparkling water with calmer, more natural branding. This blobby illustrative design full of offset patterns is meant to create a casual, relaxing, carefree look for the product that would draw in the target audience (those looking to just sip some mildly CBD-infused water and be at ease).</p>
      </project-text>

      <project-image
      size="75"
      path="/img/p/cbddrinks/beachball.jpg"
      alt="Beach Ball Can Design"/>

    </project-template>
</template>

<script>
import ProjectTemplate from '../../components/project/ProjectTemplate.vue'
import ProjectImage from '../../components/project/ProjectImage.vue'
import ProjectText from '../../components/project/ProjectText.vue'
import ProjectCarousel from '../../components/project/ProjectCarousel.vue'
import { Slide } from 'vue-carousel'

export default {
  components: { ProjectTemplate, ProjectText, ProjectImage, ProjectCarousel, Slide }
}
</script>

<style lang="scss" scoped>

</style>
